import { AccountModel } from "@Interfaces";
import postSignUp from "./Signup";
import postLoginUser from "./Login";
import postLogout from "./Logout";
import getRefreshToken from "./RefreshToken";
import postLoginUserGoogle from "./LoginGoogle";
import postLoginUserFacebook from "./LoginFacebook";
import postForgotPassword from "./ForgotPassword";
import postRenewPassword from "./RenewPassword";
import getVerifyDataUser from "./VerifyDataUser";
import updateUserData from "./UpdateUser";
import { IUserUpdateData } from "@Interfaces";
import getUserInfo from "./UserInfo";

export const AccountService = {
    createUserAccount: async (payload: AccountModel.PostSignupRequest) => {
        return postSignUp(payload);
    },
    logoutUserAccount: async () => {
        return postLogout();
    },
    loginUserAccount: async (payload: AccountModel.PostLoginRequest) => {
        return postLoginUser(payload);
    },
    loginUserGoogleAccount: async (
        payload: AccountModel.PostLoginGoogleRequest
    ) => {
        return postLoginUserGoogle(payload);
    },
    refreshUserToken: async () => {
        return getRefreshToken();
    },
    isUserNameEmailTaken: async (username: string, email: string) => {
        return getVerifyDataUser(username, email);
    },
    loginUserAccountGoogle: async (payload: AccountModel.PostLoginRequest) => {
        return postLoginUserGoogle(payload);
    },
    loginUserAccountFacebook: async (
        payload: AccountModel.PostLoginRequest
    ) => {
        return postLoginUserFacebook(payload);
    },
    forgotPassword: async (payload: AccountModel.PostForgotResponse) => {
        return postForgotPassword(payload);
    },

    renewPassword: async (payload: AccountModel.PostForgotResponse) => {
        return postRenewPassword(payload);
    },
    updateProfileSettings: async (payload: IUserUpdateData) => {
        return updateUserData(payload);
    },
    userInfo: async (jwtToken?: string | null) => {
        return getUserInfo(jwtToken);
    },
};
